module.exports = __webpack_public_path__ + "img/resource.95030e6d.png";